<template>
    <v-container>
        <v-form v-model="valid">
            <v-row>
                <v-col col="4">
                    <v-combobox
                        :items="meters"
                        item-text="name"
                        item-value="id"
                        :search-input.sync="search"
                        v-model="meter"
                        :rules="[rules.required]"
                        label="Meter">
                    </v-combobox>
                </v-col>

                <v-col col="4">
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="Inicio"
                                v-model="carga.fecha_inicio"
                                prepend-icon="mdi-calendar-month-outline"
                                readonly
                                v-on="on"
                                color='primary'
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="carga.fecha_inicio" :max="carga.fecha_fin" no-title scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu.save(carga.fecha_inicio)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col col="4">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="Fin"
                                v-model="carga.fecha_fin"
                                prepend-icon="mdi-calendar-month-outline"
                                readonly
                                v-on="on"
                                color='primary'
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="carga.fecha_fin" :max="today" :min='carga.fecha_inicio' no-title scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu1.save(carga.fecha_fin)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row justify='end'>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" :loading="load" :disabled="!valid" @click="uploadData()" class='button' v-on="on" fab large>
                            <v-icon>mdi-cloud-upload-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>upload data</span>
                </v-tooltip>
            </v-row>
        </v-form>
        <Alert :show="alert"/>  
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue'
    import moment from 'moment'
    import { api1 } from '../../globals/axios';
    import Alert from '../utilitys/Alert.vue';
    export default Vue.extend({
        name: 'Datafixerform',
        components:{
            Alert,
        },
        data: () => ({
            load: false,
            valid: false,
            meters:[],
            menu: false,
            menu1: false,
            search: null,
            type: null,
            meter: null,
            alert:{
                icon: null,
                show: false,
                text: null,
                color: null,
                time: 2000
            },
            today: moment().format("YYYY-MM-DD"),
            carga: {
                fecha_inicio: moment().format("YYYY-MM-DD"),
                fecha_fin: moment().format("YYYY-MM-DD"),
            },
            rules: {
            required: value => !!value  || 'Required.',
            }
        }),
        mounted(){
            this.refresh();
        },
        methods: {
            uploadData: function(){
                this.load = true;
                this.carga.carga = this.meter.id;
                api1({
                    method:"POST",
                    'url': '/upload-data',
                    data: this.carga

                }).then(res=>{
                    this.alert.show=true;
                    this.alert.icon='mdi-check-circle'
                    this.alert.text= res.data ? res.data.msg : res;
                    this.alert.color='success';
                    this.load=false;
                })
                .catch(error => {
                    this.alert.show=true;
                    this.alert.icon='mdi-alert'
                    this.alert.text=error.response ? error.response.data : error;
                    this.alert.color='error';
                    this.load=false;
                })
            },
            refresh: function(){
                api1({
                    method:"GET",
                    'url': '/cargas'
                }).then(res=>{
                    this.meters=res.data
                })
                .catch(error => {
                    this.alert.show=true;
                    this.alert.icon='mdi-alert'
                    this.alert.text=error.response ? error.response.data : error;
                    this.alert.color='error';
                })
                
            }
        }
    })
</script>

<style lang="scss" scoped>
.button{
    margin-left: 2rem;
}
</style>

